import React from 'react';
import { Box } from 'rebass';
import styled from 'styled-components';

import Markup from '../../base/Markup/Markup';
import Typography, {
  TypographyContextProvider,
} from '../Typography/Typography';
import IconButton from '../IconButton/IconButton';
import { parsePadding } from '../../utils/parseSpacing';
import { theme } from '../../styles/theme';
import { FeaturedCompanySlideStoryblok } from '../../types/storyblok';

const Wrapper = styled(Box)`
  position: relative;
  border: 1px solid black;
  height: 150px;
  display: flex;
  &:hover > span {
    display: block;
  }

  @media (max-width: ${theme.breakpoint.md}) {
    &:hover > span {
      display: none;
    }
  }
`;
const TitleComponent = styled(Box)`
  color: white;
  background: ${theme.colors.black};
  padding: 8px 12px;
  margin-bottom: 0;
  font-size: 0.8em;
  font-weight: bold;
  display: inline-block;
`;

const RichTextComponent = styled(Box)`
  border: 1px solid black;
  border-top: none;
  font-size: 13px;
  height: 60px;
  display: flex;
  p {
    margin-bottom: 0;
  }
`;

const IconsComponent = styled(Box)`
  border-left: 1px solid black;
  width: 30%;
  padding: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const ImageComponent = styled('img')`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  margin: auto;
`;

const Description = styled('span')`
  background: ${theme.colors.grey};
  position: absolute;
  top: 0;
  left: 0;
  padding: 20px;
  width: 100%;
  height: calc(100% + 60px);
  font-size: 13px;
  display: none;

  &:hover {
    display: block;
  }
`;
const FeaturedCompanySlide = ({
  title,
  logo,
  richText,
  description,
  colourScheme,
  links,
  logoMargin = '3',
}: FeaturedCompanySlideStoryblok) => {
  return (
    <TypographyContextProvider value={{ colourScheme }} width={1} px={4}>
      <Box width="230px" mx={['auto', 'auto', 5]} mb={[5]}>
        {title && <TitleComponent>{title}</TitleComponent>}
        {logo && (
          <Wrapper sx={{ ...parsePadding(logoMargin) }} backgroundColor="#fff">
            {description && <Description>{description}</Description>}
            <ImageComponent src={logo} loading="lazy" />
          </Wrapper>
        )}
        <RichTextComponent>
          <Box width="70%" p={['13px']}>
            {richText && <Markup content={richText} />}
          </Box>
          <IconsComponent>
            {links &&
              links.map((l) => (
                <IconButton
                  key={l.uuid || l._uid}
                  icon={l.icon}
                  link={l.link}
                  width={l.width}
                />
              ))}
          </IconsComponent>
        </RichTextComponent>
      </Box>
    </TypographyContextProvider>
  );
};

export default FeaturedCompanySlide;
